

































import { Values } from 'vue-i18n';
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import PositionSelection from './PositionSelection.vue';
import { staffTabAccess } from '../common';
import { Version } from '../types';
import { IPositionVariantItem } from './types';


const modelChangeEvent = 'change';


const getPositionVariantItemId = (item: IPositionVariantItem): string => {
    const variant = item.variant;
    if (variant === null) {
        return `position--${item.position.id}`;
    } else {
        return `variant--${variant.id}`;
    }
};


@Component({
    components: {
        PositionSelection
    }
})
export default class PositionCell extends Vue {
    // region Модель, свойства
    @Model(modelChangeEvent, {
        type: Object,
        required: false,
        default: null
    })
    public readonly value!: IPositionVariantItem | null;

    private get valueId(): string | null {
        if (this.value === null) {
            return null;
        }
        return getPositionVariantItemId(this.value);
    }

    @Prop({
        type: Array,
        required: false,
        default: () => []
    })
    public readonly allowedPosLevels!: number[];

    @Prop({
        type: Object,
        required: false,
        default: null,
    })
    public readonly version!: Version | null;
    // endregion


    // region Lifecycle
    // noinspection JSUnusedLocalSymbols
    private created() {
        if (this.value === null) {
            this.selectedPositions = [];
        } else {
            this.selectedPositions = [this.value];
        }

        this.$watch('modalVisible', () => {
            if (this.modalVisible) {
                if (this.value === null) {
                    this.selectedPositions = [];
                } else {
                    this.selectedPositions = [this.value];
                }
            }
        });
    }
    // endregion


    // region Утилиты
    get isEditable(): boolean {
        return staffTabAccess.isEditable;
    }

    private getTranslate(key: string, values?: Values): string {
        return String(this.$t(`modules.budget.staffing_table.ga_department_positions.position_cell.${key}`, values));
    }

    private getPositionText(item: IPositionVariantItem): string {
        const variant = item.variant;
        if (variant === null) {
            const position = item.position;

            const parts: string[] = [];
            if (position.category !== null) {
                parts.push(position.category.code);
            }

            if (position.categoryNumber !== null) {
                if (parts.length > 0) {
                    parts.push('-');
                }
                parts.push(position.categoryNumber);
            }

            if (parts.length > 0) {
                parts.push(' - ');
            }

            if (this.$i18n.locale.trim().toLowerCase() === 'kk') {
                parts.push(position.nameKk);
            } else {
                parts.push(position.nameRu);
            }

            return parts.join('');
        } else {
            const parts: string[] = [];
            if (variant.category !== null) {
                parts.push(variant.category.code);
            }

            if (variant.categoryNumber !== null) {
                if (parts.length > 0) {
                    parts.push('-');
                }
                parts.push(variant.categoryNumber);
            }

            if (parts.length > 0) {
                parts.push(' - ');
            }

            if (this.$i18n.locale.trim().toLowerCase() === 'kk') {
                parts.push(variant.nameKk);
            } else {
                parts.push(variant.nameRu);
            }

            return parts.join('');
        }
    }
    // endregion


    // region Основное
    private selectedPositions: Array<IPositionVariantItem> = [];

    private get selectedPosition(): IPositionVariantItem | null {
        if (this.selectedPositions.length === 0) {
            return null;
        }
        return this.selectedPositions[0];
    }

    private get selectedPositionId(): string | null {
        if (this.selectedPosition === null) {
            return null;
        }
        return getPositionVariantItemId(this.selectedPosition);
    }
    // endregion


    // region Модальное окно
    private modalVisible = false;

    private onModalCancelled() {
        if (this.value === null) {
            this.selectedPositions = [];
        } else {
            this.selectedPositions = [this.value];
        }
    }

    private onModalApplied() {
        if (this.selectedPositionId !== this.valueId) {
            this.$emit(modelChangeEvent, this.selectedPosition);
        }
    }
    // endregion
}
